import { Modal, Input, message } from "antd";
import axios from "axios";
import { Form, Button } from "antd";
import Helper from "../utils/helper";
import { ENDPOINTS } from "../constants/api";

const ResetPasswordForm = ({ visible, onOk, onCancel }) => {
  const handleSubmit = async () => {
    // {{ edit_1 }}
    const oldPassword = document.querySelector(
      'input[placeholder="Old Password"]'
    ).value;
    const newPassword = document.querySelector(
      'input[placeholder="New Password"]'
    ).value;

    // Validate password lengths
    if (oldPassword.length < 8 || newPassword.length < 8) {
      message.error("Both passwords must be at least 8 characters long.");
      return; // Exit if validation fails
    }

    const values = {
      current_password: oldPassword,
      new_password: newPassword,
    };
    await resetPassword(values);
    onOk(); // Call onOk after successful reset
  };

  return (
    <Modal
      title="Reset Password"
      open={visible}
      onOk={handleSubmit} // {{ edit_1 }}
      onCancel={onCancel}
      footer={false}
    >
      <Form onSubmitCapture={handleSubmit}>
        <Form.Item style={{ display: "none" }}>
          <Input autoComplete="username" type="text" />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="Old Password"
            style={{ marginBottom: 16 }}
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="New Password"
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%" }}
            onClick={handleSubmit} // {{ edit_1 }}
          >
            Reset Password
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const resetPassword = async (values) => {
  // {{ edit_2 }}
  try {
    const authToken = Helper.getTokenFromLocalStorage();
    const authorizationHeader = authToken ? `${authToken}` : "";

    const payload = {
      dealer_code: localStorage.getItem("dealer_code") || "", // Get dealer code
      current_password: values.current_password || "", // Get current password from form
      new_password: values.new_password || "", // Get new password from form
    };

    await axios.post(ENDPOINTS.RESET_PASSWORD, payload, {
      headers: { Authorization: authorizationHeader },
    });

    message.success("Password reset successfully!"); // Success message
    setTimeout(() => {
      message.success("Logging Out!");
    }, 2000); // Delay of 2 seconds
    setTimeout(() => {
      Helper.handleLogout();
    }, 4000); // Delay of 4 seconds (2 seconds after the previous line)
  } catch (error) {
    console.error("Failed to reset password:", error);
    message.error("Failed to reset password. Please try again.");
  }
};
export default ResetPasswordForm;
